var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.json",
  title: "Control Preview: JSON",
  description: "Read-only preview renderer for complex values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Object, array, or scalar value." }
  }
});

var helper = require("./helpers/control.preview.js");

function toPrettyText(value) {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return helper.valueToText(value);
  }
}

exports.render = async function(options) {
  var text = toPrettyText(options.value);
  if (!text) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  return helper.renderDoc({
    n: "pre",
    c: "ua-control-preview-json",
    i: text
  });
};
